"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
var index_1 = require("../index");
var Notification_1 = require("../pure-components/Notification");
/**
 * Internal component to manage individual animations and notification timeouts
 */
var NotificationWrapper = function (props) {
    var id = props.id, onClose = props.onClose, _a = props.status, status = _a === void 0 ? index_1.InfoBlockStatus.Info : _a, rest = __rest(props, ["id", "onClose", "status"]);
    // time of animation transition in & out
    var transitionDuration = 250;
    // value used for triggering CSSTransition animation
    var _b = __read(React.useState(), 2), transitionIn = _b[0], setTransitionIn = _b[1];
    // override CSS variable to keep JS and CSS transitions in sync
    document.documentElement.style.setProperty("--notification-transition-duration", transitionDuration + "ms");
    React.useEffect(function () {
        // on mount, set transitionIn to true to trigger animation in and start timer if needed
        setTransitionIn(true);
    }, []);
    var onToastClose = function (e) {
        if (onClose)
            onClose(e);
        // set transitionIn to false to trigger animation out
        setTransitionIn(false);
    };
    var onExited = function () {
        // once animation has completed, remove from the map
        ToastNotification.remove(id);
    };
    var closeRef = React.createRef();
    var wrapperRef = React.createRef();
    var preventBubble = function (e) {
        var current = closeRef.current;
        var target = e.target;
        if (current !== null && target) {
            if (current === target || current.contains(target))
                onToastClose(e);
        }
        ;
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
    React.useEffect(function () {
        var current = wrapperRef.current;
        if (current === null)
            return;
        current.addEventListener("mouseup", preventBubble);
        return function () { return current.removeEventListener("mouseup", preventBubble); };
    }, [transitionIn, wrapperRef.current]);
    return (React.createElement(react_transition_group_1.CSSTransition, { in: transitionIn, classNames: "oui-toast-transition", timeout: transitionDuration, onExited: onExited, unmountOnExit: true },
        React.createElement("div", { className: "oui-toast-notification", ref: wrapperRef },
            React.createElement(Notification_1.Notification, __assign({}, rest, { status: status, closeRef: closeRef, onClose: onToastClose })))));
};
/**
 * OUI global component for managing toast notifications.
 *
 * @oui-component ToastNotification
 */
var ToastNotification = /** @class */ (function (_super) {
    __extends(ToastNotification, _super);
    function ToastNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.internalCreate = function (notificationProps) {
            _this.setState(function (prevState) {
                var toastMap = prevState.toastMap, toastCount = prevState.toastCount;
                var newMap = new Map(toastMap);
                var count = toastCount + 1;
                var toastId = "toast-" + count;
                var notificationWrapper = (React.createElement(NotificationWrapper, __assign({}, notificationProps, { id: toastId, key: toastId })));
                newMap.set(toastId, notificationWrapper);
                return {
                    toastMap: newMap,
                    toastCount: count
                };
            });
        };
        _this.internalRemove = function (toastId) {
            _this.setState(function (prevState) {
                var toastMap = prevState.toastMap;
                var newMap = new Map(toastMap);
                newMap.delete(toastId);
                return {
                    toastMap: newMap
                };
            });
        };
        _this.componentWillUnmount = function () {
            if (ToastNotification.toastInstance === _this) {
                ToastNotification.toastInstance = null;
            }
        };
        _this.state = {
            toastMap: new Map(),
            toastCount: 0
        };
        if (ToastNotification.toastInstance === null) {
            ToastNotification.toastInstance = _this;
        }
        else {
            throw Error("There should only be one instance of ToastNotification");
        }
        return _this;
    }
    ToastNotification.prototype.render = function () {
        var toasts = Array.from(this.state.toastMap.values());
        return (React.createElement(index_1.Portal, null,
            React.createElement("div", { className: "oui-toast-notifications" }, toasts)));
    };
    ToastNotification.toastInstance = null;
    ToastNotification.getInstance = function () {
        if (!ToastNotification.toastInstance) {
            throw Error("You do not have any instances of ToastNotification in your app");
        }
        return ToastNotification.toastInstance;
    };
    ToastNotification.create = function (notificationProps) {
        ToastNotification.getInstance().internalCreate(notificationProps);
    };
    ToastNotification.remove = function (toastId) {
        ToastNotification.getInstance().internalRemove(toastId);
    };
    return ToastNotification;
}(React.Component));
exports.default = ToastNotification;
//# sourceMappingURL=ToastNotification.js.map